import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const StarStroke = createSvgIcon(
  () => (
    <path d="M36.0746 12.5938L25.809 11.1172L21.1684 1.76562C20.3949 0.148438 18.0043 0.078125 17.1605 1.76562L12.5902 11.1172L2.2543 12.5938C0.42617 12.875 -0.276955 15.125 1.05898 16.4609L8.4418 23.7031L6.68398 33.8984C6.40273 35.7266 8.37148 37.1328 9.98867 36.2891L19.1996 31.4375L28.3402 36.2891C29.9574 37.1328 31.9262 35.7266 31.6449 33.8984L29.8871 23.7031L37.2699 16.4609C38.6059 15.125 37.9027 12.875 36.0746 12.5938ZM27.4262 22.8594L29.3949 34.25L19.1996 28.9062L8.93398 34.25L10.9027 22.8594L2.60586 14.8438L14.0668 13.1562L19.1996 2.75L24.2621 13.1562L35.723 14.8438L27.4262 22.8594Z" />
  ),
  '0 0 44 44'
);
